import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addBranch, addUserType, getUserTypeCategory, updateBranch, updateUserType } from "../../../services/userMasterUser";
import {
  validateFullName,
} from "../../../components/Regex";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function BranchCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    name: state?.name || "",
    mobile: state?.mobile || "",
    emailId: state?.emailId || "",
    code: state?.code || "",
    city: state?.city || "",
    pinCode: state?.pinCode || "",
    state: state?.state || "",
    address: state?.address || "",
    location: state?.location || "",
    status: state?.status || "ACTIVE",

  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    emailId: "",
    code: "",
    city: "",
    pinCode: "",
    state: "",
    address: "",
    location: "",
    status: "",
  });

  const [userTypeCategoryData, setUserTypeCategoryData] = useState();

  useEffect(() => {
     getUserTypeCategory()
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              const services = Res.map((item) => ({
                label: item,
                value: item,
              }));
              setUserTypeCategoryData(services);
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
  }, [])

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    
    if (!(input.name)) {
      newErrors.name = "Please Correct First Name";
      isValid = false;
    } else {
      newErrors.firstName = "";
    }

    
    if (!(input.mobile)) {
      newErrors.mobile = "Please Enter Mobile";
      isValid = false;
    } else {
      newErrors.mobile = "";
    }
    
    if (!(input.emailId)) {
      newErrors.emailId = "Please Correct Email Id";
      isValid = false;
    } else {
      newErrors.emailId = "";
    }
    
    if (!(input.code)) {
      newErrors.code = "Please Correct Code";
      isValid = false;
    } else {
      newErrors.code = "";
    }
    
    if (!(input.city)) {
      newErrors.city = "Please Correct City";
      isValid = false;
    } else {
      newErrors.city = "";
    }
    
    if (!(input.pinCode)) {
      newErrors.pinCode = "Please Correct Pin Code";
      isValid = false;
    } else {
      newErrors.pinCode = "";
    }
    
    if (!(input.state)) {
      newErrors.state = "Please Correct State";
      isValid = false;
    } else {
      newErrors.state = "";
    }
    
    if (!(input.address)) {
      newErrors.address = "Please Correct Address";
      isValid = false;
    } else {
      newErrors.address = "";
    }
    
    if (!(input.location)) {
      newErrors.location = "Please Correct Location";
      isValid = false;
    } else {
      newErrors.location = "";
    }
 
    if (input.status === "") {
      newErrors.status = "Please Choose Status";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          name: input.name,
          mobile: input.mobile,
          emailId: input.emailId,
          code: input.code,
          city: input.city,
          pinCode: input.pinCode,
          state: input.state,
          address: input.address,
          location: input.location,
          status: input.status,
        };
        updateBranch(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/Branch/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          name: input.name,
          mobile: input.mobile,
          emailId: input.emailId,
          code: input.code,
          city: input.city,
          pinCode: input.pinCode,
          state: input.state,
          address: input.address,
          location: input.location,
          status: "ACTIVE"
        };
        addBranch(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/Branch/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/Branch/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Branch {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="mobile" className="form-label">
                        Mobile
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="mobile"
                        name="mobile"
                        value={input.mobile}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            mobile: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.mobile}</div>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="emailId" className="form-label">
                        Email Id
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="emailId"
                        name="emailId"
                        value={input.emailId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            emailId: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.emailId}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="code" className="form-label">
                        Code
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="code"
                        name="code"
                        value={input.code}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            code: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.code}</div>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="city" className="form-label">
                        City
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="city"
                        name="city"
                        value={input.city}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            city: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.city}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="pinCode" className="form-label">
                        Pin Code
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="pinCode"
                        name="pinCode"
                        value={input.pinCode}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            pinCode: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.pinCode}</div>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="state" className="form-label">
                        State
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="state"
                        name="state"
                        value={input.state}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            state: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.state}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="address" className="form-label">
                        Address
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="address"
                        name="address"
                        value={input.address}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            address: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.address}</div>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="location" className="form-label">
                        Location
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="location"
                        name="location"
                        value={input.location}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            location: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.location}</div>
                    </div>
                  </div>
                  
                  {state?.id && <div className="row mb-1">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
